export default class UserModel {
  constructor(attrs = {}) {
    Object.assign(this, attrs);
  }
  get(k) {
    return this[k];
  }
}
